import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const HeaderTitle: React.FC = () => {
  const [title, setTitle] = useState('');

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/') {
      setTitle('Home');
    } else {
      const base = location.pathname.split('/')[1];

      switch (base) {
        case 'admin':
          setTitle('Settings');
          break;

        case 'contacts':
        case 'people':
        case 'companies':
          setTitle('Contacts');
          break;

        case 'process-requests':
        case 'cases':
          setTitle('Cases');
          break;

        case 'notifications':
          setTitle('Notifications');
          break;

        case 'resources':
          setTitle('Resources');
          break;

        case 'tasks':
          setTitle('Tasks');
          break;

        case 'reports':
          setTitle('Reports');
          break;

        case 'custom-template':
          setTitle('Custom Template');
          break;

        case 'create-report':
          setTitle('Reporting');
          break;

        default:
          setTitle('');
          break;
      }
    }
  }, [location.pathname]);

  return <>{title}</>;
};

export default HeaderTitle;
